var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVechileLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5356 4.43943C13.576 3.47981 13.0962 3 12.5 3C11.9037 3 11.424 3.47981 10.4643 4.43943C9.88849 5.01528 9.31784 5.28263 8.49687 5.28263C7.78004 5.28263 6.76019 5.1436 6.2 5.7085C5.64424 6.26893 5.78265 7.28458 5.78265 7.99685C5.78265 8.81785 5.51528 9.38849 4.93941 9.96435C3.97981 10.924 3.50001 11.4037 3.5 12C3.50002 12.5962 3.97983 13.076 4.93944 14.0356C5.58454 14.6807 5.78265 15.0973 5.78265 16.0031C5.78265 16.72 5.64363 17.7398 6.20854 18.3C6.76896 18.8557 7.78461 18.7173 8.49685 18.7173C9.37114 18.7173 9.79215 18.8883 10.4161 19.5123C10.9474 20.0437 11.6597 21 12.5 21C13.3403 21 14.0526 20.0437 14.5839 19.5123C15.2078 18.8883 15.6289 18.7173 16.5031 18.7173C17.2154 18.7173 18.231 18.8557 18.7914 18.3M18.7914 18.3C19.3564 17.7398 19.2173 16.72 19.2173 16.0031C19.2173 15.0973 19.4154 14.6807 20.0605 14.0356C21.0202 13.076 21.5 12.5962 21.5 12C21.5 11.4037 21.0202 10.924 20.0605 9.96435M18.7914 18.3H18.8",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3501 9.75039L12.5001 12.9004L20.6003 3.90039",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVechileLocation);
export default __webpack_public_path__ + "static/media/vechileLocation.7a8d2c9c3097cad8e95d5f7261b36f2b.svg";
export { ForwardRef as ReactComponent };